// =============================================================================
// Resource type icons - registry nome icona lucide -> componente
// =============================================================================
// `ResourceType.icon` contiene il *nome* di un'icona lucide (PascalCase),
// scelto dall'utente nel form o impostato dai preset di organizzazione
// (backend/src/common/constants/tenant-presets.constants.ts). Va risolto nel
// componente corrispondente: se stampato come testo il nome sborda dal
// quadratino colorato.
// L'ordine delle chiavi è quello di presentazione nel picker e deve restare
// allineato con `ALLOWED_RESOURCE_TYPE_ICONS` lato backend
// (backend/src/common/constants/resource-type-icons.constants.ts).

import {
  User,
  Users,
  Stethoscope,
  HeartPulse,
  Microscope,
  Scissors,
  Sparkles,
  Wrench,
  Car,
  Truck,
  Bike,
  Armchair,
  DoorOpen,
  Bed,
  Warehouse,
  Building2,
  Home,
  Briefcase,
  Laptop,
  Monitor,
  Camera,
  Dumbbell,
  GraduationCap,
  Utensils,
  PawPrint,
  Boxes,
  Package,
  Layers,
  type LucideIcon,
} from 'lucide-react';

/** Icone selezionabili per un tipo di risorsa. */
export const RESOURCE_TYPE_ICONS: Record<string, LucideIcon> = {
  User,
  Users,
  Stethoscope,
  HeartPulse,
  Microscope,
  Scissors,
  Sparkles,
  Wrench,
  Car,
  Truck,
  Bike,
  Armchair,
  DoorOpen,
  Bed,
  Warehouse,
  Building2,
  Home,
  Briefcase,
  Laptop,
  Monitor,
  Camera,
  Dumbbell,
  GraduationCap,
  Utensils,
  PawPrint,
  Boxes,
  Package,
  Layers,
};

/** Nomi icona disponibili nel picker (ordine di presentazione). */
export const RESOURCE_TYPE_ICON_NAMES = Object.keys(RESOURCE_TYPE_ICONS);

/** Componente icona per il nome dato, `null` se sconosciuto o assente. */
export function resolveResourceTypeIcon(name?: string | null): LucideIcon | null {
  return (name && RESOURCE_TYPE_ICONS[name]) || null;
}
